import { BaseModel } from "src/app/core/models/base.model";
import { ActionIdEnum } from "../../enums/list-layout/action-id-enum";

export class TableActionsModel {
    model?: any; 
    actionIdSelected?: ActionIdEnum;
    index?: number;

    constructor(model:BaseModel, actionType:ActionIdEnum, index:number){
        this.model = model;
        this.actionIdSelected = actionType; 
        this.index = index;
    }
}